module.exports = __webpack_public_path__ + "static/media/Cult-Gaia-Multicolor-Gaias-Ark-Bag-Lyst_thumb.1fd897c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Cult-Gaia-Multicolor-Gaias-Ark-Bag-Lyst_thumb.png
// module id = 214
// module chunks = 0